import CollapsableContent from 'Components/Common/CollapsableContent';
import RichTextEditor from 'Components/Common/RichTextEditor';
import React from 'react'
import DOMPurify from 'dompurify';
import { sanitizeURLs } from 'utils/helpers';
import HTMLContent from 'Components/Common/HTMLContent';
interface MilestoneScriptProps {
    script: string;
    onDelete: () => void;
    onChange: (value: string) => void;
    scriptName?: string;
    disabled?: boolean
}

const MilestoneScript: React.FC<MilestoneScriptProps> = ({ script, onDelete, onChange, scriptName, disabled }) => {

    const [editMode, setEditMode] = React.useState(false);

    return (
        <div className="script-card">
            <div className="script-card-header">
                <span className="script-name">{scriptName || 'Script'}</span>
                {
                    !disabled &&
                    <div className="script-actions">
                        {
                            editMode ? (
                                <button className="edit-script" onClick={() => setEditMode(false)}>
                                    Save
                                </button>
                            ) : (
                                <button className="edit-script" onClick={() => setEditMode(true)}>
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                            <path d="M9.56817 3.2178L10.1861 2.59988C11.2099 1.57608 12.8698 1.57608 13.8936 2.59988C14.9174 3.62369 14.9174 5.2836 13.8936 6.3074L13.2757 6.92532M9.56817 3.2178C9.56817 3.2178 9.64541 4.53088 10.804 5.68948C11.9626 6.84808 13.2757 6.92532 13.2757 6.92532M9.56817 3.2178L3.88734 8.89863C3.50257 9.2834 3.31018 9.47579 3.14472 9.68792C2.94955 9.93815 2.78222 10.2089 2.64569 10.4954C2.52995 10.7382 2.44391 10.9963 2.27183 11.5126L1.54266 13.7001M13.2757 6.92532L7.59486 12.6061C7.21008 12.9909 7.0177 13.1833 6.80557 13.3488C6.55534 13.5439 6.28459 13.7113 5.99811 13.8478C5.75526 13.9635 5.49714 14.0496 4.98091 14.2217L2.79341 14.9508M2.79341 14.9508L2.25869 15.1291C2.00464 15.2137 1.72456 15.1476 1.53521 14.9583C1.34586 14.7689 1.27974 14.4888 1.36442 14.2348L1.54266 13.7001M2.79341 14.9508L1.54266 13.7001" stroke="#007AFF" />
                                        </svg>
                                    </span>
                                    Edit
                                </button>
                            )
                        }
                        <button className="delete-script" onClick={onDelete}>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path d="M13.6615 4.5H2.32812" stroke="#A5261F" strokeLinecap="round" />
                                    <path d="M12.5564 6.16797L12.2498 10.7674C12.1318 12.5373 12.0728 13.4223 11.4961 13.9618C10.9195 14.5013 10.0325 14.5013 8.25866 14.5013H7.74308C5.96921 14.5013 5.08228 14.5013 4.50561 13.9618C3.92893 13.4223 3.86994 12.5373 3.75194 10.7674L3.44531 6.16797" stroke="#A5261F" strokeLinecap="round" />
                                    <path d="M6.32812 7.83203L6.66146 11.1654" stroke="#A5261F" strokeLinecap="round" />
                                    <path d="M9.66146 7.83203L9.32812 11.1654" stroke="#A5261F" strokeLinecap="round" />
                                    <path d="M4.32812 4.5C4.36538 4.5 4.384 4.5 4.40089 4.49957C4.94985 4.48566 5.43414 4.13661 5.62094 3.62021C5.62668 3.60433 5.63257 3.58666 5.64435 3.55132L5.70908 3.35714C5.76433 3.19139 5.79196 3.1085 5.8286 3.03813C5.9748 2.75738 6.24529 2.56242 6.55786 2.51251C6.63621 2.5 6.72357 2.5 6.8983 2.5H9.09128C9.26601 2.5 9.35337 2.5 9.43172 2.51251C9.7443 2.56242 10.0148 2.75738 10.161 3.03813C10.1976 3.1085 10.2253 3.19138 10.2805 3.35714L10.3452 3.55132C10.357 3.58661 10.3629 3.60434 10.3686 3.62021C10.5554 4.13661 11.0397 4.48566 11.5887 4.49957C11.6056 4.5 11.6242 4.5 11.6615 4.5" stroke="#A5261F" />
                                </svg>
                            </span>
                            Delete
                        </button>
                    </div>
                }

            </div>
            <div className={`script-card-body ${editMode ? 'p-0' : ''}`}>
                {
                    editMode ? (
                        <RichTextEditor disabled={disabled} value={script} onChange={onChange} placeholder='Write your script here...' noBorder={true} />
                    ) : (
                        <CollapsableContent noPaddingReadMoreButton>
                            <HTMLContent content={script} />
                        </CollapsableContent>
                    )
                }
            </div>
        </div>
    )
}

export default MilestoneScript